<script setup lang="ts">
import { VBtn, VSnackbar } from 'vuetify/components';

import { useVersionCheck } from '../composables/useVersionCheck';

const props = withDefaults(
  defineProps<{
    currentVersion: string;
    pollIntervalMs?: number;
  }>(),
  {
    pollIntervalMs: 5 * 60 * 1000,
  },
);

const { updateAvailable, reload } = useVersionCheck({
  currentVersion: props.currentVersion,
  pollIntervalMs: props.pollIntervalMs,
});
</script>

<template>
  <VSnackbar v-model="updateAvailable" :timeout="-1" location="bottom">
    A new version of this app is available.
    <template #actions>
      <VBtn color="primary" variant="text" @click="reload">Refresh</VBtn>
    </template>
  </VSnackbar>
</template>
